import { useI18n } from 'vue-i18n'

/**
 * Seller 端文案：st('common.save') 等价于 t('seller.common.save')
 */
export function useSellerI18n() {
  const { t, locale, te, ...rest } = useI18n()
  const st = (key, values) => t(`seller.${key}`, values)
  const ste = (key) => te(`seller.${key}`)
  return { st, ste, t, locale, te, ...rest }
}
